import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

import buildPath from '../utilities/buildPath';

type ThisApi = ApiDefinition['/questionnaires/{questionnaireId}']['GET'];
type Input = ThisApi['params'];

const getQuestionnaireById = async ({ questionnaireId }: Input): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>('/questionnaires/{questionnaireId}', { questionnaireId });
  const data = await formsBackendClient.get(path);
  return data.data;
};

export default getQuestionnaireById;
